<template>
  <div class="flex flex-col earth-background" id = "blurry">
    <div class="navbar-div">
        <navbar-dash 
      >
        </navbar-dash>
    </div>
    <div class="slideshow-container">
      <div class='flexbox fade'  v-bind:style= "[active ? {display:'none'} : {display:'flex'}]">
        <div class="col">
          <div class='text-column'>
            <p class = "large">Create.</p>
            <p class = "large">Communicate.</p>
            <p class = "large">Captivate.</p>
            <p class = "paragraph">Springmatter no-code software empowers users to  </br>
            easily tell a personalized and meaningful story in a </br>
            beautiful way. This multi-media “narrative” is </br>
            published instantly to a webpage, which can be </br>
            shared via email or social media, magnifying user’s </br>
            ability to share, collaborate, and educate. </br>
          </p> </br>
          <button
              @click="getStarted"
              type="button"
              class="button"
            >
              <p style = "letter-spacing:0.2vh; font-weight:bold">GET STARTED</p>
            </button>
          </div>
        </div>
        <div class='col'>
            <img
                class = "hero"
                src="../assets/images/HeroImage.png"
                alt="Hero image"
                  />
        </div>
      </div>
      <div class='flexbox fade'  v-bind:style= "[active ? {display:'flex'} : {display:'none'}]">
        <div class="col">
          <div class='text-column'>
            <p class = "large">Investigate.</p>
            <p class = "large">Inspire.</p>
            <p class = "large">Impact.</p>
            <p class = "paragraph">Springmatter sets itself apart as you investigate  </br>
            and incorporate complex data and analysis from</br>
            ecology, engineering, or business. Once you share </br>
            your Narrative, our custom analytics allow you to </br>
            measure your impact based on the viewer usage </br>
            and engagement. </br>
          </p> </br>
          <button
              @click="getStarted"
              type="button"
              class="button"
            >
              <p style = "letter-spacing:0.2vh; font-weight:bold">GET STARTED</p>
            </button>
          </div>
        </div>
        <div class='col'>
            <img
                class = "hero"
                src="../assets/images/HeroImage2.png"
                alt="Hero image"
                  />
        </div>
      </div>
      <div style="text-align:center; margin-bottom: 2vh;">
          <span class="dot" v-on:click="showSlides()" :class="{'active': !active}"></span> 
          <span class="dot" v-on:click="showSlides()" :class="{'active': active}"></span> 
      </div>
    </div>
    <div class='second-row'>
          <p class = "main-title"> Start Something Meaningful. </p>
          <p class = "title" style = "font-size:5vh;"> Tell your story to the world. </p>
    </div>
      <div class='third-row'>
        <div class='column'>
            <ul style = " display: table; margin-left: auto; margin-right: 0;">
                <li>
                  <div class="box">
                    <img src="../assets/images/icons/Images.png">
                    <span style=""><p class = "small" style = "text-indent: 1vh"><button id="textButton" :class="{active:'images' == selected}" v-on:click="getImage('images')" >Images</button></p></span>
                  </div>
                </li>
                <li>
                  <div class="box">
                    <img src="../assets/images/icons/Videos.png">
                    <span style=""><p class = "small" style = "text-indent: 1vh"><button id="textButton" :class="{active:'videos' == selected}"  v-on:click="getImage('videos')">Videos</button></p></span>
                  </div>
                </li>
                <li>
                  <div class="box">
                    <img src="../assets/images/icons/Text.png">
                    <span style=""><p class = "small" style = "text-indent: 1vh"><button id="textButton" :class="{active:'text' == selected}"  v-on:click="getImage('text')">Text</button></p></span>
                  </div>
                </li>
                <li>
                  <div class="box">
                    <img src="../assets/images/icons/Data.png">
                    <span style=""><p class = "small" style = "text-indent: 1vh;"><button id="textButton" :class="{active:'data' == selected}" v-on:click="getImage('data')">Data</button></p></span>
                  </div>
                </li>
                <li>
                  <div class="box">
                    <img src="../assets/images/icons/Music.png">
                    <span style=""><p class = "small" style = "text-indent: 1vh"><button id="textButton" :class="{active:'audio' == selected}" v-on:click="getImage('audio')">Audio</button></p></span>
                  </div>
                </li>
                </ul>
          </div>

          <div class='column'>
            <img
              class = "monitor"
              :src= "monitorImage"
              alt="Monitor"
                />
          </div>
          <div class='column'  style = "flex:1.5">
          <div class='text-column-second'>
            <p class = "medium">Start with a template.</p></br>
            <p class = "small">Select from our large collection of great</br>
                  looking templates to get started quickly. </p></br></br>
            <p class = "medium">Add your content or use ours.</p></br>
             <p class = "small"> Upload your personalized multi-media </br>
               or select from our huge library of stock </br> images, videos, and audio. </p> </br></br>
            <p class = "medium"> Review your impact.</p></br>
            <p class = "small">Once you share your Narrative via email  </br>
             or social media, our custom analytics </br> 
             allow you to measure your viewer’s </br> usage and engagement.
          </p> </br>
          <button
              @click="getStarted"
              type="button"
              class="button"
            >
              <p style = "letter-spacing:0.2vh; font-weight:bold;">GET STARTED</p>
             </button>
          </div>
        </div>
      </div>
        <div class='footer' id = "contact-us">
        <div class='column'>
          <ul class = "space-y-8" style = " display: table; margin: 0 auto;  " >
                <li>
                  <div class="footer-box">
                    <img src="../assets/images/footer-icons/Phone.png" style = "max-width: 8%">
                    <span style=""><p style = "text-indent: 1vh; font-family:Poppins; color:white; font-size:2vh;">(734) 975-8777 x100</p></span>
                    </br>
                  </div>
                </li>
                <li>
                  <div class="footer-box">
                    <img src="../assets/images/footer-icons/fax.png" style = "max-width: 8%">
                    <span ><p style = "text-indent: 1vh; font-family:Poppins; color:white; font-size:2vh">(734) 975-0239</p></span>
                    </br>
                  </div>
                </li>
                <li>
                  <div class="footer-box">
                    <img src="../assets/images/footer-icons/email.png" style = "max-width: 8%">
                    <span ><p style = "text-indent: 1vh; font-family:Poppins; color:white; font-size:2vh">info@springmatter.com</p></span>
                    </br>                
                  </div>
                </li>
              </ul>
        </div>
        <div class = "column-image justify-center">
          <img
              class = "logow"
              src="../assets/images/Springmatter-Icon.png"
              alt="springmatter"
          />
        </div>
          <div class = "column">
          <ul class = "space-y-8" style = " display: table; margin: 0 auto;">
                <li>
                  <div class="footer-box">
                    <img src="../assets/images/footer-icons/address.png" style = "max-width: 5%">
                    <span><p style = "margin-left: 1.2vh; font-family:Poppins; font-size:2vh;  color:white">1777 Highland Drive, Suite B</br>
                          Ann Arbor, Michigan 48108</p></span>
                  </div>
                </li>
                <li>
                  <div class="footer-box">
                    <span><p style ="margin-left: 3.5vh; font-family:Poppins; font-size:2vh; color:white">©2000-2020 Michigan Aerospace Corporation</br>
                    All rights reserved</p></span>
                  </div>
                </li>
              
              </ul>
        </div>
      </div>
     </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NavbarDash from "@/components/NavbarDash.vue";

export default {
  components: { Breadcrumbs, NavbarDash },

  props: ["username"],

  data() {
    return {
      html: "",
      monitorImage: require("../assets/images/meaningful-section/Image.png"),
      selected: 'images',
      slideIndex: 1,
      active: false,
    };
  },

  watch: {},

  methods: {

    getImage(type){
      if (type == 'images') {
        this.monitorImage = require("../assets/images/meaningful-section/Image.png");
        this.selected = 'images';
      }
      else if (type == 'videos') {
        this.monitorImage = require("../assets/images/meaningful-section/Video.png");
        this.selected = 'videos';
      }
      else if (type == 'text') {
        this.monitorImage = require("../assets/images/meaningful-section/Text.png");
        this.selected = 'text';
      }
      else if (type == 'data') {
        this.monitorImage = require("../assets/images/meaningful-section/Data.png");
        this.selected = 'data';
      }
      else if (type == 'audio') {
        this.monitorImage = require("../assets/images/meaningful-section/Audio.png");
        this.selected = 'audio';
      }
    },

  getStarted() {
    if (this.isSignedIn()) {
      this.$router.push({
          name: "Narratives",
          params: { username: this.$store.state.users.user.username },
        });
    }
    else {
      this.login("login");
    }
  },
  isSignedIn() {
    return this.$store.state.users.user.username != undefined;
  },

  login(prompt) {
      this.$auth.loginWithRedirect({ prompt });
    },
  showSlides() {
    this.active = !this.active;
  },
  },
  computed: {
    xml() {
      return this.$markdown.render(this.html);
    },
  },

  mounted() {},
};
</script>

<style scoped >
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&display=swap');

.flexbox {
  display: -webkit-flex;
  display: none;
  margin-bottom: 8vh;
}
.active, .dot:hover {
  background-color: green;
}

/* Fading animation */
.fade {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 2s;
  animation-name: fade;
  animation-duration: 2s;
}

@-webkit-keyframes fade {
  from {opacity: .1} 
  to {opacity: 1}
}

@keyframes fade {
  from {opacity: .1} 
  to {opacity: 1}
}

.flexbox .col {
  flex: 1;
}
.earth-background {
  background: repeating-linear-gradient(#2c3e50, rgba(0, 0, 0, 0.75) 70%, #2c3e50, rgba(0, 0, 0, 0.75) 60%) , url("../assets/images/HeroBackground.jpg") no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

[class^="icon"] {
  width: 5vh;
  height: 5vh;
  position: relative;
  top: 1.5vh;
  margin-right: 1vh;
  fill: #fff;
}

nav {
  float: left;
  width: 100%;
  text-align: center;
  height: 10vh;
  padding: 1vh;
}
.box {
   display: flex;
   align-items:center;
   max-width: 45%;
   padding: 10%;

}
.footer-box {
  display: flex;
  align-items:center;


}
nav a{
    color: #282828;
    font-weight: bold;
    padding: 30px;
    text-align: center;

}
.footer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 4vh;

}
.third-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  background-color: white;
  padding: 0vh  0vh 14vh 0vh ;

}
.second-row {
  padding: 10vh;
  background-color: white;
  text-align: center;
}

.column {
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}
.column-image {
  display: flex;
  justify-content: center;
  align-items: center;
  flex:1;
}
.hero {
  margin-top: 20vh;
  max-width: 90%;
  min-width: 70%;
}

.logow {
  display: block;
  margin: auto;
  max-width: 50%;

}
.monitor {
  display: block;
  max-width: 90%;
}
.footer-icon {
  max-width: 10%
}
a:active {
  color: red;
  background-color: transparent;
}
a:hover {
  color: green;
  background-color: transparent;
}
.large {
  font-size:97px;
  font-family: "Poppins"; 
  text-align: left;
  color: white;
  line-height: 102px;
  font-weight: 600;

}
.medium {
  font-size:4vh;
  font-family: "Poppins"; 
  text-align: left;
  line-height: 4vh;
  font-weight: bold;
  

}
.small {
  font-size:2.1vh;
  font-family: "Poppins"; 
  text-align: left;
  line-height: 2.5vh;
  font-weight: 500;

}

.paragraph {
  font-size:24px;
  color: white;
  font-family: "Poppins";
  font-weight: 300;
  text-align: left;
  line-height: 33px;
  margin-top: 3vh;
}

.text-column {
   margin-left: 20%;
   margin-top: 11vh;
   word-break:break-all;
   
}


.title {
  font-family: "Poppins";
  color: black;
  font-size:5vh;
  z-index : 0;
} 
.main-title {
  font-size:8vh;
  font-weight: bold;
  font-family: "Poppins";
  color: black;
}
.text
{
  display: inline-block;
}
 .button {
  background-color: #47aa42;
  border: none;
  color: white;
  padding: 2vh 3vh 2vh 3vh;
  text-decoration: none;
  margin: 2.5vh 0.2vh;
  border-radius: 3vh;
  outline: none;
  font-size: 1.5vh;
  display:flex;
  justify-content:center;
  align-items:center;
  box-sizing:border-box;
  }
.button:hover {
  color: black;
}
#textButton {
    background:none;
    border:none;
    margin:0;
    padding:0;
    cursor: pointer;
    outline: none;
    font-weight: 600;
}
#textButton:hover {
  color: green;
}
.active {
  color: green;
}

.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 6px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}
.active, .dot:hover {
  background-color:  #47aa42;
}
@media (max-width: 1900px) {
	.large {
		font-size: 75px;
    line-height: 80px;
	}
  .paragraph {
    font-size: 22px;
    line-height: 30px;
  }
}
@media (max-width: 1500px) {
	.large {
		font-size: 53px;
    line-height: 60px;
  }
  .paragraph {
    font-size: 18px;
    line-height: 25px;
  }  
}
@media (max-width: 1200px) {
	.large {
		font-size: 45px;
    line-height: 50px;
	}
  .paragraph {
    font-size: 13px;
    line-height: 20px;
  }
}
@media (max-width: 900px) {
	.large {
		font-size: 30px;
    line-height: 34px;
	}
  .paragraph {
    font-size: 9px;
    line-height: 15px;
  }
}
@media (max-width: 600px) {
	.large {
		font-size: 19px;
    line-height: 25px;
	}
  .paragraph {
    font-size: 7px;
    line-height: 10px;
  }
}

</style>
